import { EVISITS_ROUTES } from 'screens/EVisits/constants';

import { EVisitOverview } from './EVisitOverview';
import EVisitsStateLocation from './EVisitsStateLocation';
import EVisitsSuccessScreen from './EVisitSuccessScreen';
import { RouteData } from '../navigation';

const title = 'E-Visit Appointment';
const eVisitsNavigation: RouteData[] = [
  {
    path: EVISITS_ROUTES.OVERVIEW,
    component: EVisitOverview,
    componentName: 'EVisitOverview',
    title
  },
  {
    path: EVISITS_ROUTES.STATE_SELECTOR,
    component: EVisitsStateLocation,
    componentName: 'EVisitsStateLocation',
    title
  },
  {
    path: `${EVISITS_ROUTES.REQUEST_SUCCESS}/:encounterId?`,
    component: EVisitsSuccessScreen,
    componentName: 'EVisitSuccessScreen',
    title
  }
];

export default eVisitsNavigation;
